import React from "react";

function AboutUs() {
  return (
    <div className="flex h-full w-full" id="about_us">
      <div className="m-10">
        <div className="text-4xl">
          Welcome to
          <span className="pl-2 font-bold text-4xl text-[#4c9a2a]">
            MPPMNGPL
          </span>
        </div>
        <div className="w-[100px] h-0.5 bg-green-900 my-5"></div>

        <article>
          <br />
          <h2 className="text-[#4c9a2a] font-bold text-lg pb-2">Background</h2>
          <p>
            The
            <strong>
              {" "}
              Mounts Palay-Palay–Mataas-na-Gulod Protected Landscape (MPPMNGPL){" "}
            </strong>
            is a <strong> 3,972.70-hectare (9,816.75-acre)</strong> protected
            area encompassing the Palay-Palay Mountain Range in Southwestern
            Luzon island near Manila in the Philippines. It was established on
            <strong> 26 October 1976 </strong> as a national park and game
            refuge and bird sanctuary covering an initial area of 4,000 hectares
            (9,900 acres).
          </p>
          <br />
          <p>
            In <strong> 2007 </strong>, the national park was designed as a
            protected landscape area under the National Integrated Protected
            Areas System through Proclamation No. <strong> 1315 </strong> signed
            by President Gloria Arroyo. The park is the{" "}
            <strong> last remaining lowland rainforest </strong> in the province
            of Cavite and is well known for Mount Pico de Loro, a popular
            destination for mountaineers and hikers from Metro Manila.
          </p>

          <br />
          <p>
            The Palay-Palay protected landscape area is situated in the mountain
            range that forms the border between the densely populated province
            of <strong> Cavite and Batangas </strong> in the Calabarzon region.
            It contains parts of the municipalities of{" "}
            <strong> Marogondon and Ternate </strong> in Cavite and
            <strong> Nasubgu </strong> in Batangas and is spread over four
            barangays namely{" "}
            <strong> Sapang, Pinagsanhan, Patungan, and Papaya, </strong> and
            seven sitios, namely
            <strong>
              {" "}
              Malauyas, Caynipa, Caytako, Cacabay, Magabe, Murangdalig and
              Hamilo{" "}
            </strong>
            . It is bounded on the north by the coves and beaches of Ternate
            including <strong> Caylabne Bay and Puerto Azul </strong>, on the
            south by the{" "}
            <strong> rolling hills and farmlands of Nasugbu </strong>, on the
            west by <strong> Limbones Cove </strong>, and on the east by{" "}
            <strong> rolling plateau of Marogondon.</strong>
          </p>
          <br />
          <p>
            The mountain range consists of two prominent extinct volcanoes,
            namely <strong> Mount Palay-Palay </strong> at{" "}
            <strong> 688 metres (2,257 ft) high </strong>and{" "}
            <strong>
              {" "}
              Mount Mataas na Gulod, 642 metres (2,106 ft) high.{" "}
            </strong>{" "}
            Mount Palay-Palay located in the{" "}
            <strong> park’s northern portion </strong>, covers{" "}
            <strong> 60% </strong>
            of the protected area. A major atttraction in the park is{" "}
            <strong> Mount Pico de Loro </strong> at the{" "}
            <strong> southern portion </strong> which was named for the towering
            formation at its summit which resembles a aparrot’s beak. It is also
            the{" "}
            <strong>
              {" "}
              highest mountain in Cavite at 688 metres (2,257 ft){" "}
            </strong>{" "}
            where hikers are rewarded with the scenic view of the Manila Bay and
            its islands and South China Sea, as well as the coves and beaches of
            Nasugbu including <strong>
              {" "}
              Mounts Batulao and Talamitam.{" "}
            </strong>{" "}
            Other notable peaks in the mountain range include{" "}
            <strong>
              {" "}
              Mount Marami, Mount Buntis and Mount Nagpatong{" "}
            </strong>{" "}
            where the Filipino revolutionary Andres Bonifacio was executed in
            1897.
          </p>
        </article>

        <article>
          <br />
          <h2 className="text-[#4c9a2a] font-bold text-lg pb-2">
            Significance
          </h2>
          <p>
            The protected landscape is an important bird area having been
            initially proclaimed a{" "}
            <strong> game refuge and bird sanctuary. </strong> It is home to a
            diverse bird species such as the{" "}
            <strong>
              {" "}
              Philippine eagle-owl, Philippine falconet, Philippine hawk-cuckoo,
              Philippine drongo-cuckoo, Philippine hawk-owl, ashy thrush,
              brahminy kite, crested serpent eagle, Philippine fairy-bluebird,
              Philippine trogon, black-chinned fruit dove, island swiftlet,
              Philippine bulbul, Pacific swallow, Luzon hornbill and Philippine
              pygmy woodpecker.{" "}
            </strong>{" "}
            Mts. Palay-Palay/Mataas na Gulod Protected Landscape also has the
            presumption of being the major watershed for the province of Cavite.
            It is the <strong>
              {" "}
              major water source for all the rivers{" "}
            </strong>{" "}
            and <strong> tributaries </strong> that supplies the surrounding
            municipalities all the way that goes as far as the Manila Bay.
          </p>
        </article>

        <article>
          <br />
          <h2 className="text-[#4c9a2a] font-bold text-lg pb-2">
            BIODIVERSITY
          </h2>
          <p>
            <br />
            <strong>Notable Species</strong>
            <br />
            <br />
            <strong>Flora/Fauna Database</strong>
            <br />
            <br />
            <strong>THE PROTECTED AREA SYSTEM</strong>
            <br />
            <br />
            <strong>What is a Protected Area?</strong>
            <br />
          </p>

          <br />
          <p>
            <strong> The Philippine Protected Area System </strong> – The
            Philippines is renowned as one of the countries with the highest
            biodiversity in the world. As a matter of fact, it has{" "}
            <strong> 52,177 described species, </strong> half of which are
            endemic. It is a home for more than{" "}
            <strong> 1,130 terrestrial species </strong> (49% are endemic) and
            it has a{" "}
            <strong> floral biodiversity of 10,000-14,000 species </strong>{" "}
            (more than half are endemic) (DENR-PAWB, n.d.). During the 80s, the
            effects of deforestation and loss of habitat were already evident
            due to the major exportation of timber. Industrialization and
            continuous unwise use of resources threatened the country’s
            ecological balance. Due to this, although the country has many
            endemic species, some of these life forms are critically endangered
            such as the{" "}
            <strong>
              {" "}
              infamous Philippine eagle, Philippine crocodile, and tamaraw{" "}
            </strong>{" "}
            (DENR-PAWB, n.d.).
          </p>

          <br />
          <p>
            To conserve the environment and protect the country’s biodiversity,
            efforts were made to ratify the constitution and to formulate new
            laws to prevent environmental degradation (Viña et al., 2010). In
            1987, the{" "}
            <strong> Philippine Strategy for Sustainable Development </strong>{" "}
            was drafted by the{" "}
            <strong>
              {" "}
              Department of Environmental and Natural Resources (DENR){" "}
            </strong>{" "}
            with the aim of achieving sustainable development. To attain this
            goal, the integrated protected areas system was formulated
            (Philippine Government, 1989). This advocacy received funding from
            different international organizations and later on, a bill regarding
            protected areas was presented to the Congress in 1991. In 1992, this
            bill was signed into law by President Aquino as the NIPAS act.
          </p>
        </article>

        <article>
          <br />
          <h2 className="text-[#4c9a2a] font-bold text-lg pb-2">
            The NIPAS act
          </h2>
          <p>
            <strong> The NIPAS act of 1992 </strong> – Also referred to as{" "}
            <strong> RA 7586, </strong>primarily aims to secure for the Filipino
            people of present and future generations the perpetual existence of
            all native plants and animals through the establishment of a
            comprehensive system of integrated protected areas within the
            classification of national park as provided for in the Constitution.
            The <strong> National Integrated Protected Areas System </strong>{" "}
            refers to “the classification and administration of all designated
            protected areas to maintain essential ecological processes and life
            support systems, to preserve genetic diversity, to ensure
            sustainable use of resources found therein, and to maintain their
            natural conditions to the greatest extent possible”. The{" "}
            <strong> NIPAS act </strong>
            covers all protected areas whether{" "}
            <strong> terrestrial, coastal or marine. </strong>
            Since 1992, a total of <strong> 234 protected areas </strong>{" "}
            covering <strong> 5.23 million hectares </strong> and{" "}
            <strong> 22 million hectares </strong> buffer zone were governed
            under the NIPAS Act (DEBR, 2009). As an act of congress, the NIPAS
            act of 1992 was amended to ENIPAS Law of 2018 (RA 11038, signed June
            22, 2018).
          </p>
        </article>
      </div>
    </div>
  );
}

export default AboutUs;
